import type { OnPageTransitionEndAsync } from 'vike/types';
import { analytics } from '#website/components/Analytics/analytics';

export const onPageTransitionEnd: OnPageTransitionEndAsync = async () => {
	document.querySelector('body')?.classList.remove('page-is-transitioning');
	if (import.meta.env.PUBLIC_ENV__APP_ENV === 'production') {
		analytics.page({ referrer: document.referrer || undefined });
	}
};
